import * as Api from '@ViewModels';
import { useCallback, useState } from 'react';

const findJobTitleValue = (criteria: Api.IContactFilterCriteria[]): string => {
	const criterion = criteria?.find(c => c.property === Api.ContactFilterCriteriaProperty.JobTitle);
	return criterion?.value ?? '';
};

export const useJobTitleFilter = (initialFilterCriteria: Api.IContactFilterCriteria[] = []) => {
	const [jobTitle, setJobTitle] = useState(() => findJobTitleValue(initialFilterCriteria));

	const getJobTitleCriteria = useCallback((): Api.IContactFilterCriteria[] => {
		if (!jobTitle.trim()) {
			return [];
		}

		return [
			{
				property: Api.ContactFilterCriteriaProperty.JobTitle,
				value: jobTitle.trim(),
			},
		];
	}, [jobTitle]);

	const refreshJobTitleFilter = useCallback((criteria: Api.IContactFilterCriteria[]) => {
		setJobTitle(findJobTitleValue(criteria));
	}, []);

	const clearJobTitleFilter = useCallback(() => {
		setJobTitle('');
	}, []);

	const hasJobTitleFilter = jobTitle.trim() !== '';

	const isJobTitleCriteria = useCallback((criterion: Api.IContactFilterCriteria): boolean => {
		return criterion.property === Api.ContactFilterCriteriaProperty.JobTitle;
	}, []);

	return {
		jobTitle,
		setJobTitle,
		getJobTitleCriteria,
		refreshJobTitleFilter,
		clearJobTitleFilter,
		hasJobTitleFilter,
		isJobTitleCriteria,
	};
};
